import { createTheme } from '@mui/material/styles';
import { themeObject } from 'remote/global';

const theme = createTheme(themeObject);

export default theme;
